// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking-services-notice {
  min-width: 0;
  margin: 12px 0;
  padding: 14px 16px;
  border: 1px solid #e8ca83;
  border-radius: 12px;
  background: #fff8e8;
  color: #58471e;
  font-size: 14px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.booking-services-notice h2 {
  margin: 0 0 8px;
  font-size: 16px;
  line-height: 1.4;
}
.booking-services-notice p {
  margin: 8px 0;
}
.booking-services-notice summary {
  cursor: pointer;
  padding: 6px 0;
}
.booking-services-notice ul {
  margin: 6px 0 12px;
  padding-left: 22px;
}
.booking-services-notice a {
  display: inline-block;
  padding: 8px 0;
  color: #68531b;
  font-weight: 600;
  text-decoration: underline;
}
.booking-services-notice .booking-services-notice-hint {
  font-size: 12px;
  margin-bottom: 0;
}
.booking-services-notice.booking-services-explained {
  background: #f5f6f9;
  border-color: #dce1ea;
  color: #4c576b;
}
.booking-services-notice blockquote {
  margin: 12px 0;
  padding: 10px 12px;
  border-left: 3px solid #a6afc1;
  background: #fff;
}
.booking-services-notice blockquote footer {
  font-size: 12px;
}
.booking-services-notice .booking-services-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0;
}
.booking-services-notice .booking-services-actions button {
  min-height: 44px;
  border: 1px solid #c8b47c;
  border-radius: 9px;
  padding: 9px 12px;
  background: #fff;
  color: #58471e;
  font: inherit;
  cursor: pointer;
}
.booking-services-notice .booking-services-actions button:disabled {
  opacity: 0.55;
  cursor: default;
}
.booking-services-notice .booking-services-editor, .booking-services-notice .booking-services-reason {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #d8c89d;
}
.booking-services-notice .booking-services-editor h3, .booking-services-notice .booking-services-reason h3 {
  margin: 0 0 12px;
  font-size: 15px;
}
.booking-services-notice .booking-services-editor > label, .booking-services-notice .booking-services-reason > label {
  display: grid;
  gap: 6px;
}
.booking-services-notice .booking-services-editor select, .booking-services-notice .booking-services-editor textarea, .booking-services-notice .booking-services-reason select, .booking-services-notice .booking-services-reason textarea {
  width: 100%;
  box-sizing: border-box;
  min-height: 44px;
  font-size: 16px;
  border: 1px solid #d3c6a8;
  border-radius: 8px;
  padding: 10px;
  color: #232137;
  background: #fff;
}
.booking-services-notice .booking-services-editor [role=alert], .booking-services-notice .booking-services-reason [role=alert] {
  color: #a71b34;
}
.booking-services-notice .booking-services-options {
  margin: 12px 0;
  padding: 10px;
  border: 1px solid #d8c89d;
  border-radius: 8px;
  min-width: 0;
  max-height: 420px;
  overflow-y: auto;
}
.booking-services-notice .booking-services-options > label {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 8px 0;
  border-bottom: 1px solid #e9dfc8;
}
.booking-services-notice .booking-services-options input {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  margin: 2px 0;
}
.booking-services-notice .booking-services-options span {
  min-width: 0;
  display: grid;
  gap: 3px;
}
.booking-services-notice .booking-services-options strong {
  font-size: 14px;
  font-weight: 500;
}
.booking-services-notice .booking-services-options small {
  font-size: 12px;
}
.booking-services-notice .booking-services-success {
  color: #32775b;
}
.booking-services-notice.booking-services-notice-error {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  align-items: center;
}
.booking-services-notice.booking-services-notice-error button {
  border: 1px solid #d5bf89;
  border-radius: 8px;
  background: #fff;
  padding: 8px 12px;
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/pages/shared/bookingServicesNotice.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AACF;AAAE;EAAK,eAAA;EAAiB,eAAA;EAAiB,gBAAA;AAKzC;AAJE;EAAI,aAAA;AAON;AANE;EAAU,eAAA;EAAiB,cAAA;AAU7B;AATE;EAAK,kBAAA;EAAoB,kBAAA;AAa3B;AAZE;EAAI,qBAAA;EAAuB,cAAA;EAAgB,cAAA;EAAgB,gBAAA;EAAkB,0BAAA;AAmB/E;AAlBE;EAAgC,eAAA;EAAiB,gBAAA;AAsBnD;AArBE;EAA+B,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AA0B7E;AAzBE;EAAa,cAAA;EAAgB,kBAAA;EAAoB,8BAAA;EAAgC,gBAAA;AA+BnF;AA/BqG;EAAS,eAAA;AAkC9G;AAjCE;EAA4B,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,cAAA;AAuCxE;AAtCI;EAAS,gBAAA;EAAkB,yBAAA;EAA2B,kBAAA;EAAoB,iBAAA;EAAmB,gBAAA;EAAkB,cAAA;EAAgB,aAAA;EAAe,eAAA;AAgDlJ;AA/CI;EAAkB,aAAA;EAAc,eAAA;AAmDpC;AAjDE;EAAqD,gBAAA;EAAkB,iBAAA;EAAmB,6BAAA;AAsD5F;AArDI;EAAK,gBAAA;EAAkB,eAAA;AAyD3B;AAxDI;EAAU,aAAA;EAAe,QAAA;AA4D7B;AA3DI;EAAmB,WAAA;EAAa,sBAAA;EAAwB,gBAAA;EAAkB,eAAA;EAAiB,yBAAA;EAA2B,kBAAA;EAAoB,aAAA;EAAe,cAAA;EAAgB,gBAAA;AAsE7K;AArEI;EAAe,cAAA;AAwEnB;AAtEE;EAA4B,cAAA;EAAgB,aAAA;EAAe,yBAAA;EAA2B,kBAAA;EAAoB,YAAA;EAAc,iBAAA;EAAmB,gBAAA;AA+E7I;AA9EI;EAAU,aAAA;EAAe,uBAAA;EAAyB,QAAA;EAAU,cAAA;EAAgB,gCAAA;AAqFhF;AApFI;EAAQ,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,aAAA;AA0FvD;AAzFI;EAAO,YAAA;EAAc,aAAA;EAAe,QAAA;AA8FxC;AA7FI;EAAS,eAAA;EAAiB,gBAAA;AAiG9B;AAjGkD;EAAQ,eAAA;AAoG1D;AAlGE;EAA4B,cAAA;AAqG9B;AApGE;EAAkC,aAAA;EAAe,eAAA;EAAiB,aAAA;EAAe,mBAAA;AA0GnF;AAzGI;EAAS,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,iBAAA;EAAmB,cAAA;AAgHjG","sourcesContent":[".booking-services-notice {\n  min-width: 0;\n  margin: 12px 0;\n  padding: 14px 16px;\n  border: 1px solid #e8ca83;\n  border-radius: 12px;\n  background: #fff8e8;\n  color: #58471e;\n  font-size: 14px;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n  h2 { margin: 0 0 8px; font-size: 16px; line-height: 1.4; }\n  p { margin: 8px 0; }\n  summary { cursor: pointer; padding: 6px 0; }\n  ul { margin: 6px 0 12px; padding-left: 22px; }\n  a { display: inline-block; padding: 8px 0; color: #68531b; font-weight: 600; text-decoration: underline; }\n  .booking-services-notice-hint { font-size: 12px; margin-bottom: 0; }\n  &.booking-services-explained { background: #f5f6f9; border-color: #dce1ea; color: #4c576b; }\n  blockquote { margin: 12px 0; padding: 10px 12px; border-left: 3px solid #a6afc1; background: #fff; footer { font-size: 12px; } }\n  .booking-services-actions { display: flex; flex-wrap: wrap; gap: 8px; margin: 12px 0;\n    button { min-height: 44px; border: 1px solid #c8b47c; border-radius: 9px; padding: 9px 12px; background: #fff; color: #58471e; font: inherit; cursor: pointer; }\n    button:disabled { opacity: .55; cursor: default; }\n  }\n  .booking-services-editor, .booking-services-reason { margin-top: 14px; padding-top: 12px; border-top: 1px solid #d8c89d;\n    h3 { margin: 0 0 12px; font-size: 15px; }\n    > label { display: grid; gap: 6px; }\n    select, textarea { width: 100%; box-sizing: border-box; min-height: 44px; font-size: 16px; border: 1px solid #d3c6a8; border-radius: 8px; padding: 10px; color: #232137; background: #fff; }\n    [role=alert] { color: #a71b34; }\n  }\n  .booking-services-options { margin: 12px 0; padding: 10px; border: 1px solid #d8c89d; border-radius: 8px; min-width: 0; max-height: 420px; overflow-y: auto;\n    > label { display: flex; align-items: flex-start; gap: 9px; padding: 8px 0; border-bottom: 1px solid #e9dfc8; }\n    input { flex: 0 0 18px; width: 18px; height: 18px; margin: 2px 0; }\n    span { min-width: 0; display: grid; gap: 3px; }\n    strong { font-size: 14px; font-weight: 500; } small { font-size: 12px; }\n  }\n  .booking-services-success { color: #32775b; }\n  &.booking-services-notice-error { display: flex; flex-wrap: wrap; gap: 8px 14px; align-items: center;\n    button { border: 1px solid #d5bf89; border-radius: 8px; background: #fff; padding: 8px 12px; color: inherit; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
